import React from "react"

function NextStep() {
	return (
		<svg
			className="mx-auto my-[27px] sm:my-[50px] block"
			width={41}
			height={41}
			viewBox="0 0 41 41"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="20.5" cy="20.5" r="20.5" fill="#046A38" />
			<path d="M20.5 30L12.2728 15.75L28.7272 15.75L20.5 30Z" stroke="white" strokeWidth={2} />
		</svg>
	)
}

export default NextStep
